module.exports = __webpack_public_path__ + "img/lc-close.efdb4eeb.svg";